import RadioButtonField from "../../Utils/RadioButtonField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
const GettingReadyForAJob = ({ formik }) => {
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={careerProfileLabels.gettingReadyJob.gettingReadyForJob_1.label}
          value={formik.values.readyJob_1}
          setValue={formik.setFieldValue}
          valueName={
            careerProfileLabels.gettingReadyJob.gettingReadyForJob_1.value
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.gettingReadyJob.gettingReadyForJob_2.label}
          value={formik.values.readyJob_2}
          setValue={formik.setFieldValue}
          valueName={
            careerProfileLabels.gettingReadyJob.gettingReadyForJob_2.value
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.gettingReadyJob.gettingReadyForJob_3.label}
          value={formik.values.readyJob_3}
          setValue={formik.setFieldValue}
          valueName={
            careerProfileLabels.gettingReadyJob.gettingReadyForJob_3.value
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <RadioButtonField
          label={careerProfileLabels.gettingReadyJob.gettingReadyForJob_4.label}
          value={formik.values.readyJob_4}
          setValue={formik.setFieldValue}
          valueName={
            careerProfileLabels.gettingReadyJob.gettingReadyForJob_4.value
          }
        />
      </div>
    </>
  )
}
export default GettingReadyForAJob
